import React, { useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

// Add lottie.host URLs here as you source them — same 3D isometric style as Brain/Award
const LOTTIE_ICONS = {
  Brain: "https://lottie.host/ea906d1c-ab4f-49a3-a943-a671f91b4090/YzHdHtxleI.lottie",
  Award: "https://lottie.host/deec74bd-e85e-45f8-b9aa-f0d3e101c6f9/PqVjG36ugH.lottie",
  TrendingUp: "", // TODO: paste TrendingUp/analytics 3D lottie URL
  Shield: "" // TODO: paste Shield/security 3D lottie URL
};

const FeatureBox = ({ icon, title, description, color = "accent" }) => {
    const cardRef = useRef(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const colorClasses = {
    accent: "bg-accent text-white",
    primary: "bg-primary text-white", 
    success: "bg-success text-white",
    warning: "bg-warning text-white"
  };

  const handleMouseMove = (e) => {
    const card = cardRef?.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    setTilt({ x: y * -10, y: x * 10 });
  };

  const handleMouseLeave = () => setTilt({ x: 0, y: 0 });

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        transform: `perspective(1000px) rotateX(${tilt?.x}deg) rotateY(${tilt?.y}deg)`,
        transition: 'transform 0.15s ease-out'
      }}
      className="group relative bg-white rounded-2xl p-6 border border-border overflow-hidden transition-shadow duration-300 hover:shadow-2xl [transform-style:preserve-3d]"
    >
      {/* Liquid glass sheen on hover */}
      <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-br from-white/60 via-white/10 to-transparent backdrop-blur-[2px]" />
            <div className="relative z-10 flex flex-col items-center text-center space-y-4 [transform:translateZ(20px)]">
        {/* Icon Container */}
                <div
          className={`w-16 h-16 rounded-full flex items-center justify-center overflow-hidden group-hover:scale-110 group-hover:-translate-y-1 transition-transform duration-300 ${
            LOTTIE_ICONS?.[icon] ? '' : colorClasses?.[color]
          }`}
        >
          {LOTTIE_ICONS?.[icon] ? (
            <DotLottieReact
              src={LOTTIE_ICONS?.[icon]}
              loop
              autoplay
              style={{ width: '100%', height: '100%' }}
            />
          ) : (
            <Icon name={icon} size={28} color="white" />
          )}
        </div>
        
        {/* Title */}
        <h3 className="text-xl font-semibold text-foreground group-hover:text-accent transition-colors duration-300">
          {title}
        </h3>
        
        {/* Description */}
        <p className="text-muted-foreground leading-relaxed">
          {description}
        </p>
        
        {/* Hover Arrow */}
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 mt-2">
          <Icon name="ArrowRight" size={20} color="var(--color-accent)" />
        </div>
      </div>
    </div>
  );
};

export default FeatureBox;